import React from 'react';

export const Logora = (props) => (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 144" preserveAspectRatio="xMidYMid meet" {...props}>
        <g transform="translate(0.000000,144.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path d="M574 1415 c-458 -105 -694 -594 -488 -1011 89 -180 256 -317 454
            -371 89 -24 271 -24 360 0 247 68 439 260 507 507 24 89 24 271 0 360 -67 245
            -260 439 -502 506 -82 22 -254 27 -331 9z m318 -24 c309 -79 518 -350 518
            -671 0 -388 -302 -690 -690 -690 -388 0 -690 302 -690 690 0 319 208 590 514
            670 98 26 249 26 348 1z"/>
            <path d="M1135 1054 c-99 -34 -98 -34 -92 -40 6 -6 197 54 197 62 0 9 -39 1 -105 -22z"/>
            <path d="M739 1015 c-85 -39 -154 -55 -236 -55 -66 0 -85 -9 -113 -55 -18 -29
            -22 -47 -18 -91 5 -60 35 -102 89 -124 34 -15 35 -16 9 -122 -11 -46 -20 -104
            -20 -130 l0 -48 65 0 65 0 0 103 c0 56 5 119 11 140 10 38 11 39 47 33 20 -4
            71 -18 114 -33 l76 -26 30 21 c46 33 66 85 70 183 5 101 -9 159 -46 199 -40
            43 -59 43 -143 5z m138 -47 c21 -41 29 -178 14 -235 -15 -53 -41 -86 -63 -78
            -41 16 -69 163 -49 255 20 91 66 118 98 58z"/>
            <path d="M357 944 c-32 -18 -89 -125 -69 -132 7 -2 12 -10 12 -17 0 -21 59
            -85 78 -85 12 0 11 5 -7 24 -25 26 -38 96 -27 140 3 13 20 38 37 55 33 33 22 40 -24 15z"/>
            <path d="M1088 873 c28 -2 76 -2 105 0 28 2 5 3 -53 3 -58 0 -81 -1 -52 -3z"/>
            <path d="M1046 731 c8 -8 173 -61 190 -61 25 0 -22 21 -97 44 -94 28 -108 31 -93 17z"/>
        </g>
    </svg>
)